import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-delete-fax-folder-modal",
  templateUrl: "./delete-fax-folder-modal.component.html",
  styleUrls: ["./delete-fax-folder-modal.component.scss"],
})
export class DeleteFaxFolderModalComponent {
  @Input() folderName = "";

  @Output() close = new EventEmitter();
  @Output() submit = new EventEmitter();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.DeleteFaxFolder;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmitClick() {
    this._modalService.closeModal();
    this.submit.emit();
  }
}
